import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Trophy, Medal, TrendingUp, Users, Download, Search, Filter, ArrowUp, ArrowDown, Minus, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Mock Data
const mockScores = [{
  id: 1,
  name: 'Kota Surabaya',
  type: 'Kab/Kota',
  province: 'Jawa Timur',
  totalScore: 95,
  rank: 1,
  campaignScore: 98,
  postingScore: 92,
  engagementScore: 95,
  trend: '+2.5%',
  status: 'hijau'
}, {
  id: 2,
  name: 'DKI Jakarta',
  type: 'Provinsi',
  province: 'DKI Jakarta',
  totalScore: 92,
  rank: 2,
  campaignScore: 95,
  postingScore: 90,
  engagementScore: 91,
  trend: '+1.2%',
  status: 'hijau'
}, {
  id: 3,
  name: 'Kota Bandung',
  type: 'Kab/Kota',
  province: 'Jawa Barat',
  totalScore: 88,
  rank: 3,
  campaignScore: 85,
  postingScore: 90,
  engagementScore: 89,
  trend: '-0.5%',
  status: 'hijau'
}, {
  id: 4,
  name: 'Kab. Tangerang',
  type: 'Kab/Kota',
  province: 'Banten',
  totalScore: 65,
  rank: 45,
  campaignScore: 60,
  postingScore: 70,
  engagementScore: 65,
  trend: '-2.1%',
  status: 'kuning'
}, {
  id: 5,
  name: 'Kab. Bekasi',
  type: 'Kab/Kota',
  province: 'Jawa Barat',
  totalScore: 45,
  rank: 102,
  campaignScore: 40,
  postingScore: 50,
  engagementScore: 45,
  trend: '+0.5%',
  status: 'merah'
}];
export function SkorKinerjaPage() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const columns = [{
    header: 'Rank',
    cell: (row: any) => <div className="flex items-center gap-2" data-id="element-2585">
          {row.rank === 1 && <Trophy className="h-5 w-5 text-yellow-500" data-id="element-2586" />}
          {row.rank === 2 && <Medal className="h-5 w-5 text-gray-400" data-id="element-2587" />}
          {row.rank === 3 && <Medal className="h-5 w-5 text-amber-600" data-id="element-2588" />}
          <span className={`font-bold ${row.rank <= 3 ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-2589">
            #{row.rank}
          </span>
        </div>
  }, {
    header: 'Nama Daerah',
    cell: (row: any) => <div className="cursor-pointer hover:text-primary-600" onClick={() => navigate('/command-center/profil-penerima')} data-id="element-2590">
          <div className="font-medium text-gray-900" data-id="element-2591">{row.name}</div>
          <div className="text-xs text-gray-500" data-id="element-2592">
            {row.type} • {row.province}
          </div>
        </div>
  }, {
    header: 'Skor Total',
    cell: (row: any) => <div className="text-lg font-bold text-primary-600" data-id="element-2593">
          {row.totalScore}
        </div>
  }, {
    header: 'Breakdown Skor',
    cell: (row: any) => <div className="flex gap-4 text-xs text-gray-600" data-id="element-2594">
          <div title="Campaign Completion" className="text-center" data-id="element-2595">
            <span className="block font-medium text-gray-900" data-id="element-2596">
              {row.campaignScore}
            </span>
            <span className="text-[10px]" data-id="element-2597">Campaign</span>
          </div>
          <div title="Posting Quality" className="text-center" data-id="element-2598">
            <span className="block font-medium text-gray-900" data-id="element-2599">
              {row.postingScore}
            </span>
            <span className="text-[10px]" data-id="element-2600">Posting</span>
          </div>
          <div title="Engagement Rate" className="text-center" data-id="element-2601">
            <span className="block font-medium text-gray-900" data-id="element-2602">
              {row.engagementScore}
            </span>
            <span className="text-[10px]" data-id="element-2603">Engage</span>
          </div>
        </div>
  }, {
    header: 'Tren',
    cell: (row: any) => <div className={`flex items-center gap-1 text-sm font-medium ${row.trend.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-2604">
          {row.trend.startsWith('+') ? <ArrowUp className="h-3 w-3" data-id="element-2605" /> : <ArrowDown className="h-3 w-3" data-id="element-2606" />}
          {row.trend}
        </div>
  }, {
    header: 'Status',
    cell: (row: any) => <StatusBadge status={row.status} data-id="element-2607">
          {row.status === 'hijau' ? 'Sangat Baik' : row.status === 'kuning' ? 'Cukup' : 'Kurang'}
        </StatusBadge>
  }];
  return <CommandCenterLayout title="Skor Kinerja Daerah" subtitle="Evaluasi performa daerah berdasarkan partisipasi kampanye dan engagement" data-id="element-2608">
      <div className="space-y-6" data-id="element-2609">
        {/* Top Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2610">
          <Card className="bg-gradient-to-br from-yellow-50 to-white border-yellow-200" data-id="element-2611">
            <CardContent className="p-6" data-id="element-2612">
              <div className="flex items-center gap-4" data-id="element-2613">
                <div className="p-3 bg-yellow-100 rounded-full text-yellow-600" data-id="element-2614">
                  <Trophy className="h-8 w-8" data-id="element-2615" />
                </div>
                <div data-id="element-2616">
                  <p className="text-sm font-medium text-yellow-800" data-id="element-2617">
                    Top Performer
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-2618">
                    Kota Surabaya
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-2619">
                    Skor Tertinggi: 95/100
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-blue-50 to-white border-blue-200" data-id="element-2620">
            <CardContent className="p-6" data-id="element-2621">
              <div className="flex items-center gap-4" data-id="element-2622">
                <div className="p-3 bg-blue-100 rounded-full text-blue-600" data-id="element-2623">
                  <TrendingUp className="h-8 w-8" data-id="element-2624" />
                </div>
                <div data-id="element-2625">
                  <p className="text-sm font-medium text-blue-800" data-id="element-2626">
                    Rata-rata Nasional
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-2627">76.5</h3>
                  <p className="text-xs text-green-600 flex items-center" data-id="element-2628">
                    <ArrowUp className="h-3 w-3 mr-1" data-id="element-2629" /> +2.4% bulan ini
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-purple-50 to-white border-purple-200" data-id="element-2630">
            <CardContent className="p-6" data-id="element-2631">
              <div className="flex items-center gap-4" data-id="element-2632">
                <div className="p-3 bg-purple-100 rounded-full text-purple-600" data-id="element-2633">
                  <Users className="h-8 w-8" data-id="element-2634" />
                </div>
                <div data-id="element-2635">
                  <p className="text-sm font-medium text-purple-800" data-id="element-2636">
                    Partisipasi Aktif
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-2637">412/514</h3>
                  <p className="text-xs text-gray-500" data-id="element-2638">
                    Daerah aktif bulan ini
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Main Table */}
        <Card data-id="element-2639">
          <CardHeader className="flex flex-row items-center justify-between" data-id="element-2640">
            <CardTitle data-id="element-2641">Leaderboard Kinerja</CardTitle>
            <Button variant="outline" size="sm" onClick={() => navigate('/command-center/admin/scoring-rules')} className="gap-2" data-id="element-2642">
              <Settings className="h-4 w-4" data-id="element-2643" /> Konfigurasi Skor
            </Button>
          </CardHeader>
          <CardContent data-id="element-2644">
            <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-2645">
              <div className="relative flex-1" data-id="element-2646">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-2647" />
                <Input placeholder="Cari daerah..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2648" />
              </div>
              <div className="flex gap-2" data-id="element-2649">
                <Select data-id="element-2650">
                  <option data-id="element-2651">Semua Wilayah</option>
                  <option data-id="element-2652">Jawa</option>
                  <option data-id="element-2653">Sumatera</option>
                </Select>
                <Select data-id="element-2654">
                  <option data-id="element-2655">Urutkan: Ranking</option>
                  <option data-id="element-2656">Urutkan: Skor Tertinggi</option>
                  <option data-id="element-2657">Urutkan: Nama A-Z</option>
                </Select>
                <Button variant="outline" className="gap-2" data-id="element-2658">
                  <Download className="h-4 w-4" data-id="element-2659" /> Export
                </Button>
              </div>
            </div>

            <DataTable data={mockScores} columns={columns} keyExtractor={item => item.id} data-id="element-2660" />
          </CardContent>
        </Card>
      </div>
    </CommandCenterLayout>;
}